/* src/components/item-card/item-card.component.scss */
@keyframes border-glow {
  from {
    box-shadow: 0 0 5px 5px rgba(0, 140, 188, 0);
    border: 1px solid rgba(0, 140, 188, 0);
  }
  50% {
    box-shadow: 0 0 5px 5px rgba(0, 140, 188, 0.2);
    border: 1px solid rgba(0, 140, 188, 0.5);
  }
  to {
    box-shadow: 0 0 5px 5px rgba(0, 140, 188, 0);
    border: 1px solid rgba(0, 140, 188, 0);
  }
}
app-item-card {
  position: relative;
  z-index: 1;
  display: block;
  --body-height: auto;
}
app-item-card.item-card--size-md {
  --body-height: 200px;
}
app-item-card.item-card--clickable {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
app-item-card.item-card--proposal-changeable {
  border-radius: 10px;
  animation: border-glow 2s;
  animation-iteration-count: 3;
  border: 1px solid transparent;
}
app-item-card.item-card--proposal-changeable:hover {
  border: 1px solid rgba(0, 140, 188, 0.5);
}
.item-card {
  position: relative;
  z-index: 1;
  border: var(--vwui-border-base);
  border-color: var(--vwui-table--border-color, var(--vwui--color--border-light));
  border-radius: var(--vwui--radius--md);
  overflow: hidden;
  display: block;
  word-break: break-word;
  box-shadow: var(--vwui--shadow--md);
}
.item-card--selected {
  border-color: var(--vwui--color--primary);
}
.item-card__checkbox {
  pointer-events: none;
  position: absolute;
  z-index: 2;
  top: -1px;
  left: -1px;
  --vwui-checkbox--radius: 0 0 var(--vwui-checkbox--radius) 0;
}
.item-card__title {
  font-weight: var(--vwui--font--semibold);
  font-size: inherit;
  margin-bottom: var(--vwui--spacing--xxs);
  max-width: calc(100% - 4.5rem);
  width: calc(100% - 4.5rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-card__description {
  margin-bottom: var(--vwui--spacing--xs);
}
.item-card__label {
  color: var(--vwui-color-neutral-1);
  font-weight: var(--vwui--font--semibold);
}
.item-card__warning {
  color: var(--vwui-color-warning);
  margin-right: 0.5rem;
}
.item-card__warning--right {
  float: right;
}
.item-card__body {
  position: relative;
  z-index: 1;
  height: var(--body-height);
  overflow: hidden;
  padding: 1.25rem var(--vwui--spacing--lg);
  padding-bottom: 0;
  box-sizing: border-box;
}
.item-card__body:after {
  content: "";
  display: block;
  position: absolute;
  z-index: 2;
  bottom: -1px;
  left: -1px;
  right: -1px;
  height: 60px;
  background:
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      rgb(255, 255, 255) 90%);
}
.item-card__footer {
  padding: 0.5rem var(--vwui--spacing--lg);
  border-top: 1px solid var(--vwui-table--border-color, var(--vwui--color--border-light));
}
.item-card__footer--empty {
  display: none;
}
/*# sourceMappingURL=item-card.component-JXZGM47J.css.map */
